import {ReactElement, useMemo} from "react"
import {Warehouse} from "./api/warehouse"
import {Item} from "./api/item"
import {ProjectedStock} from "./projectedstock"
import {ScenariosTableRowDetail} from "./ScenariosTableRowDetail"

type Props = {
  count: number,
  item: Item,
  warehouses: readonly Warehouse[],
  projectedStocks: readonly ProjectedStock[]
}

export function ScenariosTableRow(
    {count, item, warehouses, projectedStocks}: Props
): ReactElement {


  const countByItemCode = useMemo(
    () => new Map([[item.code, count]]), [item, count])
  return <tr>
    <td className="count">{count}</td>
    <td className="itemCode">{item.code}</td>
    <td className="itemDescription">{item.description}</td>
    <ScenariosTableRowDetail
      countByItemCode={countByItemCode}
      projectedStocks={projectedStocks}
      warehouses={warehouses} isSummary={false}/>
  </tr>
}

